import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLayerAuthoritiesQueryVariables = Types.Exact<{
  source: Types.Scalars['String']['input'];
}>;


export type GetLayerAuthoritiesQuery = { __typename?: 'query_root', jurisdiction_boundaries: Array<{ __typename?: 'jurisdiction_boundaries', id: any, name: string, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string } | null, authorities: Array<{ __typename?: 'jurisdiction_boundary_authorities', id: any, work_kind: string, authority_name?: string | null, source_attribute?: string | null, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string } | null }> }> };


export const GetLayerAuthoritiesDocument = gql`
    query getLayerAuthorities($source: String!) {
  jurisdiction_boundaries(
    where: {source: {_eq: $source}, effective_to: {_is_null: true}}
    order_by: {name: asc}
  ) {
    id
    name
    jurisdiction {
      id
      name
    }
    authorities(order_by: {work_kind: asc}) {
      id
      work_kind
      authority_name
      source_attribute
      jurisdiction {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetLayerAuthoritiesQuery__
 *
 * To run a query within a React component, call `useGetLayerAuthoritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayerAuthoritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayerAuthoritiesQuery({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetLayerAuthoritiesQuery(baseOptions: Apollo.QueryHookOptions<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables> & ({ variables: GetLayerAuthoritiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>(GetLayerAuthoritiesDocument, options);
      }
export function useGetLayerAuthoritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>(GetLayerAuthoritiesDocument, options);
        }
export function useGetLayerAuthoritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>(GetLayerAuthoritiesDocument, options);
        }
export type GetLayerAuthoritiesQueryHookResult = ReturnType<typeof useGetLayerAuthoritiesQuery>;
export type GetLayerAuthoritiesLazyQueryHookResult = ReturnType<typeof useGetLayerAuthoritiesLazyQuery>;
export type GetLayerAuthoritiesSuspenseQueryHookResult = ReturnType<typeof useGetLayerAuthoritiesSuspenseQuery>;
export type GetLayerAuthoritiesQueryResult = Apollo.QueryResult<GetLayerAuthoritiesQuery, GetLayerAuthoritiesQueryVariables>;